export default [{
  "btn_color": "rgb(252, 192, 46)",
  "progress_color": [],
}, {
  "btn_color": "rgb(246, 124, 1)",
  "progress_color": [],
}, {
  "btn_color": "rgb(230, 74, 25)",
  "progress_color": [],
}, {
  "btn_color": "rgb(216, 27, 67)",
  "progress_color": [],
}, {
  "btn_color": "rgb(142, 36, 170)",
  "progress_color": [],
}, {
  "btn_color": "rgb(81, 45, 167)",
  "progress_color": [],
}, {
  "btn_color": "rgb(31, 135, 232)",
  "progress_color": [],
}, {
  "btn_color": "rgb(0, 135, 129)",
  "progress_color": [],
}, {
  "btn_color": "rgb(5, 160, 69)",
  "progress_color": [],
}, {
  "btn_color": "rgb(254, 216, 53)",
  "progress_color": [],
}, {
  "btn_color": "rgb(251, 140, 0)",
  "progress_color": [],
}, {
  "btn_color": "rgb(245, 81, 30)",
  "progress_color": [],
}, {
  "btn_color": "rgb(235, 29, 78)",
  "progress_color": [],
}, {
  "btn_color": "rgb(156, 40, 177)",
  "progress_color": [],
}, {
  "btn_color": "rgb(93, 53, 176)",
  "progress_color": [],
}, {
  "btn_color": "rgb(32, 151, 243)",
  "progress_color": [],
}, {
  "btn_color": "rgb(2, 150, 136)",
  "progress_color": [],
}, {
  "btn_color": "rgb(76, 176, 80)",
  "progress_color": [],
}, {
  "btn_color": "rgb(255, 235, 60)",
  "progress_color": [],
}, {
  "btn_color": "rgb(255, 167, 39)",
  "progress_color": [],
}, {
  "btn_color": "rgb(254, 87, 34)",
  "progress_color": [],
}, {
  "btn_color": "rgb(235, 65, 101)",
  "progress_color": [],
}, {
  "btn_color": "rgb(170, 71, 188)",
  "progress_color": [],
}, {
  "btn_color": "rgb(103, 59, 183)",
  "progress_color": [],
}, {
  "btn_color": "rgb(66, 165, 246)",
  "progress_color": [],
}, {
  "btn_color": "rgb(38, 165, 154)",
  "progress_color": [],
}, {
  "btn_color": "rgb(131, 198, 131)",
  "progress_color": [],
}, {
  "btn_color": "rgb(255, 241, 118)",
  "progress_color": [],
}, {
  "btn_color": "rgb(255, 183, 78)",
  "progress_color": [],
}, {
  "btn_color": "rgb(255, 138, 102)",
  "progress_color": [],
}, {
  "btn_color": "rgb(241, 98, 126)",
  "progress_color": [],
}, {
  "btn_color": "rgb(185, 104, 199)",
  "progress_color": [],
}, {
  "btn_color": "rgb(121, 134, 204)",
  "progress_color": [],
}, {
  "btn_color": "rgb(100, 181, 246)",
  "progress_color": [],
}, {
  "btn_color": "rgb(128, 203, 196)",
  "progress_color": [],
}, {
  "btn_color": "rgb(165, 214, 167)",
  "progress_color": [],
}, {
  "btn_color": "rgb(255, 245, 156)",
  "progress_color": [],
}, {
  "btn_color": "rgb(255, 204, 128)",
  "progress_color": [],
}, {
  "btn_color": "rgb(255, 171, 145)",
  "progress_color": [],
}, {
  "btn_color": "rgb(251, 135, 158)",
  "progress_color": [],
}, {
  "btn_color": "rgb(207, 147, 217)",
  "progress_color": [],
}, {
  "btn_color": "rgb(158, 168, 219)",
  "progress_color": [],
}, {
  "btn_color": "rgb(144, 202, 248)",
  "progress_color": [],
}, {
  "btn_color": "rgb(178, 223, 220)",
  "progress_color": [],
}, {
  "btn_color": "rgb(200, 230, 202)",
  "progress_color": [],
}, {
  "type":'transparent',
  "btn_color": "rgb(254, 254, 254)",
  "progress_color": [],
}, {
  "btn_color": "rgb(255, 255, 255)",
  "progress_color": [],
}, {
  "btn_color": "rgb(222, 222, 222)",
  "progress_color": [],
}, {
  "btn_color": "rgb(169, 169, 169)",
  "progress_color": [],
}, {
  "btn_color": "rgb(75, 75, 75)",
  "progress_color": [],
}, {
  "btn_color": "rgb(53, 53, 53)",
  "progress_color": [],
}, {
  "btn_color": "rgb(33, 33, 33)",
  "progress_color": [],
}, {
  "btn_color": "rgb(0, 0, 0)",
  "progress_color": [],
}]



// WEBPACK FOOTER //
// ./src/components/my_color_picker/color_config.js